import DownloadAndPrintCard from "@components/DownloadAndPrintCard";
import { Loading, PDFViewer, useFetchFile, UserTypeEnum } from "@cpj-ai/panel-npm-package";
import { Tab, Tabs } from "@heroui/react";
import { useRef } from "react";

interface IResumeTabContentProps {
  cpjResume?: string;
  cv?: string;
}

interface TabContentProps {
  fileUrl?: string;
  iframeRef: React.RefObject<HTMLIFrameElement>;
  emptyMessage: string;
}

const TabContent = ({ fileUrl, iframeRef, emptyMessage }: TabContentProps) => {
  const { data, loading } = useFetchFile({ urlPath: fileUrl, userType: UserTypeEnum.ORG });

  const getFileExtension = (filename?: string) => {
    if (!filename) return "";
    return filename.split(".").pop()?.toLowerCase() ?? "";
  };

  const renderContent = () => {
    if (!fileUrl) {
      return <p className="text-center text-lg mt-20">{emptyMessage}</p>;
    }
    const extension = getFileExtension(fileUrl);
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp"];

    if (loading) {
      return <Loading />;
    }

    if (imageExtensions.includes(extension)) {
      return (
        <div className="flex justify-center">
          <img src={data} alt="Resume" className="max-w-full object-contain max-h-[80vh]" />
        </div>
      );
    }

    if (extension === "pdf") {
      return (
        <>
          <DownloadAndPrintCard pdfUrl={data} iframeRef={iframeRef} />
          <div className="mt-4">
            <PDFViewer url={data} height="80vh" iframeRef={iframeRef} />
          </div>
        </>
      );
    }

    return <p className="text-center text-lg mt-20 text-red-500">This file format is not supported</p>;
  };

  return renderContent();
};

const ResumeTabContent = ({ cpjResume, cv }: IResumeTabContentProps) => {
  const cpjResumeIframeRef = useRef<HTMLIFrameElement>(null);
  const cvIframeRef = useRef<HTMLIFrameElement>(null);

  return (
    <div className="w-full">
      <Tabs
        aria-label="Resume Tabs"
        color="success"
        radius="full"
        classNames={{
          tabList: "bg-[#ECECE6]",
          tabContent: "text-black",
        }}
      >
        <Tab key="cpj-resume" title="CPJ Resume">
          <TabContent fileUrl={cpjResume} iframeRef={cpjResumeIframeRef} emptyMessage="No CPJ Resume Added Yet" />
        </Tab>
        <Tab key="cv" title="Employee CV">
          <TabContent fileUrl={cv} iframeRef={cvIframeRef} emptyMessage="No CV Added Yet" />
        </Tab>
      </Tabs>
    </div>
  );
};

export default ResumeTabContent;
